import React, { useState, useEffect } from 'react';
import WizardContainer from './wizard/wizard-container';
import WelcomeHelpModal from './welcome-help-modal';
import './welcome-screen.css';
import { useSimulation } from '../contexts';

import femmeImage from '@assets/svg/normal/femme.png'
import hommeImage from '@assets/svg/normal/homme.png';
import logoImage from '@assets/svg/normal/logo-addict.svg';

const WelcomeScreen = () => {
  const { currentStep: simulationStep, setCurrentStep: setSimulationStep, resetSimulation } = useSimulation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showWizard, setShowWizard] = useState(false);
  const [currentStep, setLocalCurrentStep] = useState(null);
  
  useEffect(() => {
    if (simulationStep && simulationStep !== 'null') {
      setLocalCurrentStep(simulationStep);
      setShowWizard(true);
    }
  }, [simulationStep]);
  
  const navigateToFemme = () => {
    const initialStep = 'f-0';
    resetSimulation();
    setSimulationStep(initialStep);
    setLocalCurrentStep(initialStep);
    setShowWizard(true);
  };
  
  const navigateToHomme = () => {
    const initialStep = 'h-1';
    resetSimulation();
    setSimulationStep(initialStep);
    setShowWizard(true);
  };

  const handleBackToWelcome = () => {
    resetSimulation();
    setShowWizard(false);
    setLocalCurrentStep(null);
  };
  
  const openModal = () => {
    setIsModalOpen(true);
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  if (showWizard && currentStep) {
    return <WizardContainer onBackToWelcome={handleBackToWelcome} />;
  }
  
  return (
    <div className="welcome-container">
      <header className="welcome-header">
        <div className="logo">
          <img src={logoImage} alt="Addict" />
        </div>
        <h1 className="header-title">Je crée MON abonnement sans engagement</h1>
        <div className="help-welcome-icon" onClick={openModal}>
          <span>?</span>
        </div>
      </header>
      
      <div className="welcome-content">
        <div className="welcome-section femme-section" onClick={navigateToFemme}>
          <div className="image-container">
            <img src={femmeImage} alt="Femme" className="profile-image" />
          </div>
          <div className="section-text">
            <h2>JE SUIS<br/></h2>
            <span className="script-text">une femme</span>
          </div>
        </div>
        
        <div className="welcome-section homme-section" onClick={navigateToHomme}>
          <div className="image-container">
            <img src={hommeImage} alt="Homme" className="profile-image" />
          </div>
          <div className="section-text">
            <h2>JE SUIS<br/></h2>
            <span className="script-text">un homme</span>
          </div>
        </div>
        
        <div className="welcome-footer">
          <h3 className="footer-title">Un look toujours parfait,<br />à prix malin !</h3>
          <p className="footer-subtitle">
            Un abonnement sur-mesure,<br />
            à des tarifs préférentiels.
          </p>
        </div>
      </div>
      
      {/* Modal d'aide */}
      <WelcomeHelpModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default WelcomeScreen;
